module.exports = __webpack_public_path__ + "static/0052-d543567110910e485256c125f89014fe.png";